import { render, staticRenderFns } from "./cinture.vue?vue&type=template&id=629856e5&"
import script from "./cinture.vue?vue&type=script&lang=ts&"
export * from "./cinture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports